import {Injectable} from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  loader = 0;

  addLoading() {
    this.loader++;
  }

  stopLoading() {
    if (this.loader > 0) {
      this.loader--;
    }
  }

}




